import * as React from "react";
import Select, { MenuPlacement } from "react-select";

export interface ISelectOption {
    label: string;
    value: string | number;
}

interface ISearchableSelectProps {
    // label?: string;
    placeholder?: string;
    fieldName: string;
    selectedValue?: string | number;
    options: ISelectOption[];
    isClearable?: boolean;
    onChange?: (value: string | number, fieldName?: string) => void;
    customStyle?: any;
    placement?: MenuPlacement;
    className?: string;
    isDisabled?: boolean;
    hasError?: boolean;
    // isMultiple?: boolean;
}

export function SearchableSelect(props: ISearchableSelectProps) {

    const { placeholder, fieldName, options, isClearable, customStyle, placement, className, isDisabled, selectedValue, hasError, ...otherProps } = props;

    //styles for the dropdown
    let customDropdownStyles = {
        control: (base: any, state: any) => ({
            ...base,
            border: 0,
            borderBottom: hasError ? "1px solid #ff0000" : (state.isFocused ? "1px solid #ff2e73" : "1px solid #d8d8d8"),
            borderRadius: 0,
            minHeight: "unset",
            boxShadow: state.isFocused ? 0 : 0,
            cursor: "pointer",
            '&:hover': {
                boxShadow: state.isFocused ? 0 : 0
            },
        }),
        placeholder: (base: any, state: any) => ({
            color: "#5f9ea0",
            fontSize: 12,
            position: "absolute",
            marginLeft: 4,
            fontFamily: "BrandonTextWeb-Regular",
            fontStyle: "italic",
        }),
        indicatorSeparator: (base: any, state: any) => ({
            display: "none"
        }),
        indicatorsContainer: (base: any, state: any) => ({
            ...base,
            '& svg': { display: 'none' },
            "::before": {
                content: "'>'",
                display: "inline-block",
                fontFamily: "BrandonTextWeb-Bold",
                transform: "rotate(90deg)",
                position: "absolute",
                right: 5,
                color: "black",
                fontSize: 14,
            }
        }),

        valueContainer: (base: any, state: any) => ({
            ...base,
            padding: 0
        }),
        input: (base: any, state: any) => ({
            ...base,
            paddingTop: 0,
            paddingBotton: 1,
            margin: 0
        })
    };

    const changeHandler = (selectedOption: ISelectOption) => {
        props.onChange(selectedOption.value, fieldName);
    }
    const currentValue = selectedValue ? options && options.find(({ value }) => value === selectedValue) : null;

    return (
        <div className={className ? `searchable-select-wrapper ${className}` : "searchable-select-wrapper"}>
            {/* <label className="select-label">{label}</label> */}
            <Select name={fieldName}
                isDisabled={isDisabled}
                options={options}
                value={currentValue}
                onChange={changeHandler}
                placeholder={placeholder}
                isClearable={isClearable}
                styles={customStyle ? customStyle : customDropdownStyles}
                menuPlacement={placement}
            />

        </div>
    )
}